module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "ys-dialog-container",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-layout', {
    staticClass: "ys-dialog-dismiss",
    attrs: {
      "row": "",
      "wrap": ""
    },
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "ys-dialog ys-product-dialog",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "pr-2": ""
    }
  }, [_c('div', {
    staticClass: "product-cover",
    style: ({
      'background-image': 'url(' + _vm.product.covers[0].cover.url + ')'
    })
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "x12": "",
      "mt-4": "",
      "mb-3": "",
      "py-2": "",
      "border-top": "",
      "border-bottom": ""
    }
  }, [_c('h4', [_vm._v("Product Info")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "x12": "",
      "product-name": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.product.name) + "\n      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "x12": ""
    }
  }, [_c('label', [_vm._v("Product id: "), _c('span', [_vm._v(_vm._s(_vm.product.id))])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "x12": ""
    }
  }, [_c('label', [_vm._v("Upload Date: "), _c('span', [_vm._v(_vm._s(_vm._f("formatDate")(_vm.product.created_at)))])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "x12": ""
    }
  }, [_c('label', [_vm._v("Current Price: "), _c('span', [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.product.price)))])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "x12": "",
      "mt-4": "",
      "mb-3": "",
      "py-2": "",
      "border-top": "",
      "border-bottom": ""
    }
  }, [_c('h4', [_vm._v("Total Sales")])]), _vm._v(" "), _c('v-list', {
    attrs: {
      "subheader": "",
      "two-line": ""
    }
  }, [_c('v-list-tile', {
    key: _vm.user.slug
  }, [_c('v-list-tile-avatar', {
    staticClass: "mr-2"
  }, [_c('img', {
    attrs: {
      "src": _vm.user.avatar.url
    }
  })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    domProps: {
      "innerHTML": _vm._s(_vm.user.username)
    }
  }), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Uploader")])], 1)], 1), _vm._v(" "), _vm._l((_vm.product.contributors), function(c) {
    return (_vm.product.collaborators && _vm.product.collaborators.length > 0) ? _c('v-list-tile', {
      key: c.user.slug
    }, [_c('v-list-tile-avatar', {
      staticClass: "mr-2"
    }, [_c('img', {
      attrs: {
        "src": c.user.avatar.url
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(c.user.username)
      }
    }), _vm._v(" "), _c('v-list-tile-sub-title', {
      domProps: {
        "innerHTML": _vm._s(c.user_role)
      }
    })], 1)], 1) : _vm._e()
  })], 2)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "border-left": ""
    }
  }, [_c('v-tabs', {
    staticClass: "white",
    attrs: {
      "dark": ""
    },
    model: {
      value: (_vm.active_tab),
      callback: function($$v) {
        _vm.active_tab = $$v
      },
      expression: "active_tab"
    }
  }, [_c('v-tabs-bar', {
    staticClass: "transparent pl-4 mb-3"
  }, [_vm._l((_vm.tabs), function(tab) {
    return _c('v-tabs-item', {
      key: tab.id,
      attrs: {
        "href": ("#" + (tab.id)),
        "ripple": ""
      }
    }, [_vm._v(_vm._s(tab.title))])
  }), _vm._v(" "), _c('v-tabs-slider', {
    attrs: {
      "color": "black"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    staticClass: "user-serach search-input mr-4",
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.searchValue),
      callback: function($$v) {
        _vm.searchValue = $$v
      },
      expression: "searchValue"
    }
  })], 2), _vm._v(" "), _c('v-tabs-items', {
    staticStyle: {
      "border": "none"
    }
  }, [_c('v-tabs-content', {
    key: "items",
    attrs: {
      "id": "items"
    }
  }, [_c('v-data-table', {
    staticClass: "table-wrapper",
    attrs: {
      "headers": _vm.items_headers,
      "items": _vm.items,
      "pagination": _vm.items_pagination,
      "rows-per-page-items": _vm.per_page_options,
      "total-items": _vm.total_items
    },
    on: {
      "update:pagination": function($event) {
        _vm.items_pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_c('div', {
          staticClass: "avatar-image-wrapper"
        }, [_c('div', {
          staticClass: "avatar-image",
          style: ({
            'background-image': 'url(' + props.item.order.customer.avatar.url + ')'
          })
        }), _vm._v(" "), _c('div', {
          staticClass: "avatar-title"
        }, [_vm._v(_vm._s(props.item.order.customer.username))])])]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm._f("formatDate")(props.item.order.created_at)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v("$" + _vm._s(_vm._f("formatNumber")(props.item.price)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.item.quantity))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v("$" + _vm._s(_vm._f("formatNumber")(props.item.shipping_cost)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v("$" + _vm._s(_vm._f("formatNumber")(props.item.tax_cost)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm.fullAddress(props.item.order.shipping_address)))])]
      }
    }])
  })], 1), _vm._v(" "), _c('v-tabs-content', {
    key: "open_tickets",
    attrs: {
      "id": "open_tickets"
    }
  }, [_c('v-data-table', {
    staticClass: "table-wrapper",
    attrs: {
      "headers": _vm.open_tickets_headers,
      "items": _vm.open_tickets,
      "pagination": _vm.open_tickets_pagination,
      "rows-per-page-items": _vm.per_page_options,
      "total-items": _vm.total_open_tickets
    },
    on: {
      "update:pagination": function($event) {
        _vm.open_tickets_pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_c('div', {
          staticClass: "avatar-image-wrapper"
        }, [_c('div', {
          staticClass: "avatar-image",
          style: ({
            'background-image': 'url(' + props.item.open_user.avatar.url + ')'
          })
        }), _vm._v(" "), _c('div', {
          staticClass: "avatar-title"
        }, [_vm._v(_vm._s(props.item.open_user.username))])])]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(_vm._f("formatDate")(props.item.created_at)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.item.reason))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.item.description))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_c('v-menu', {
          attrs: {
            "down": "",
            "offset-y": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "round": ""
          },
          slot: "activator"
        }, [_c('v-icon', {
          attrs: {
            "dark": "",
            "right": ""
          }
        }, [_vm._v("more_horiz")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
          staticClass: "default-menu-item",
          nativeOn: {
            "click": function($event) {
              _vm.closeTicket(props.item)
            }
          }
        }, [_c('v-list-tile-title', [_c('label', [_vm._v("Close")])])], 1)], 1)], 1)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-tabs-content', {
    key: "closed_tickets",
    attrs: {
      "id": "closed_tickets"
    }
  }, [_c('v-data-table', {
    staticClass: "table-wrapper",
    attrs: {
      "headers": _vm.closed_tickets_headers,
      "items": _vm.closed_tickets,
      "pagination": _vm.closed_tickets_pagination,
      "rows-per-page-items": _vm.per_page_options,
      "total-items": _vm.total_closed_tickets
    },
    on: {
      "update:pagination": function($event) {
        _vm.closed_tickets_pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_c('div', {
          staticClass: "avatar-image-wrapper"
        }, [_c('div', {
          staticClass: "avatar-image",
          style: ({
            'background-image': 'url(' + props.item.open_user.avatar.url + ')'
          })
        }), _vm._v(" "), _c('div', {
          staticClass: "avatar-title"
        }, [_vm._v(_vm._s(props.item.open_user.username))])])]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(_vm._f("formatDate")(props.item.created_at)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(_vm._f("formatDate")(props.item.closed_at)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.item.reason))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.item.description))])]
      }
    }])
  })], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ec0286d0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/components/product_detail_dialog.vue
// module id = 1863
// module chunks = 180